import { boardState, BoardStatus, setStatus } from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import {
  getDevicesActivation,
  putDevicesActivationOutput,
  resetDevicesActivation
} from 'common/modules/domain/deviceActivate';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';
import { Glossary } from 'common/utils/glossary';
import { AppState } from 'pages';
import { useDispatch, useSelector } from 'react-redux';
import ActFileDownloadConfirmationBoard from '../components/ActFileDownloadConfirmationBoard';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  return {
    isDisplay:
      boardState.status ===
      BoardStatus.DEVICE_ACTIVATE_DOWNLOAD_CONFIRMATION_DISP,
    purchaseIdForDeviceActivation: boardState.selectedPurchaseIdForTerminal,
    glossary: Glossary.instance(glState)
  };
};

type SelectedState = ReturnType<typeof useStateProps>;

/**
 * Actionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const cookie = loadCookie();
  const _token = cookie[SasCookieKeys.KEY_TOKEN];
  const _refreshToken = cookie[SasCookieKeys.KEY_REFRESH_TOKEN];
  const _purchaseIdForDeviceActivation = state.purchaseIdForDeviceActivation;

  // 閉じるボタンの処理
  const onClickClose = () => {
    // 最初に取得した有償機能アクティベート情報一覧をクリア
    dispatch(resetDevicesActivation());
    // 有償ファームウェアのアクティベート一覧取得APIを実行
    dispatch(
      getDevicesActivation(
        _token,
        _refreshToken,
        _purchaseIdForDeviceActivation,
        false,
        false
      )
    );
    // 機能アクティベート管理画面を表示
    dispatch(setStatus(BoardStatus.DEVICE_ACTIVATE_DISP));
  };

  // はいボタンの処理
  const onClickYes = () => {
    // アクティベーションファイルのダウンロード時の確認ダイアログを閉じる
    dispatch(setStatus(BoardStatus.DEVICE_ACTIVATE_DISP));

    // 有償ファームウェアのアクティベート確定API実行
    dispatch(
      putDevicesActivationOutput(
        _token,
        _refreshToken,
        _purchaseIdForDeviceActivation,
        state.glossary,
        false
      )
    );
  };

  return {
    onClickClose: onClickClose,
    onClickYes: onClickYes
  };
};

/**
 * アクティベーションファイルのダウンロード時の確認ダイアログ全体のContainer Component
 */
export default function ContainerComponent(ownProps: { isMobile?: boolean }) {
  const _props = { ...useStateProps(), ...useMargeProps(useStateProps()) };
  return <ActFileDownloadConfirmationBoard {...{ ..._props, ...ownProps }} />;
}
